import { render } from "./PreventiveSportsSplints.vue?vue&type=template&id=89ee63ba"
import script from "./PreventiveSportsSplints.vue?vue&type=script&lang=js"
export * from "./PreventiveSportsSplints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__